// extracted by mini-css-extract-plugin
export default {"form":"createCategory_form__nkotr","formInputBlock":"createCategory_formInputBlock__t7FpU","formInput":"createCategory_formInput__1VbZF"};